/*
 * @Author: Teemo Ding
 * @Date: 2021-08-04 16:33:27
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-04 16:47:10
 * @FilePath: /unifyxp-v2-store-portal/src/layout/CustomerDatabaseLayout/CustomerDatabaseLayout.tsx
 */
import React from 'react';

import { menuArray } from '@/src/config/SiderConfig/CustomerDatabaseSiderConfig';
import T from 'src/layout/Components/PageStructure/PageStructure';
import { useClearSalesChannel } from 'src/constrains/SalesChannelHOC/useSalesChannel';

const DbLayout = (props) => {
  React.useEffect(() => {
    useClearSalesChannel();
  }, []);
  return <T menuArray={menuArray}>{props.children}</T>;
};
export default DbLayout;
